import { Fade, IconButton, Popover, Stack, TableCell } from '@mui/material'
import type { TableHeadCellProps } from './types'
import { styles } from './styles'
import { FilterIcon, SortAscIcon, SortDeskIcon } from './icons'
import { useState } from 'react'

export const TableHeadCell = (props: TableHeadCellProps) => {
  const { item } = props

  const [filter, setFilter] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [hidden, setHidden] = useState<boolean>(false)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (filter) {
      setHidden(false)
    } else {
      setAnchorEl(event.currentTarget)
    }
  }
  const handleClose = (mode?: boolean) => {
    if (mode === undefined ? filter : mode) {
      setHidden(true)
    } else {
      setAnchorEl(null)
    }
  }

  return (
    <TableCell sx={styles.root}>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={'4px'}
      >
        {item.text}
        {(item.sort || item.filter) && (
          <Stack direction={'row'} alignItems={'center'} spacing={'0px'}>
            {item.sort && (
              <IconButton
                onClick={() => {
                  item.sort(item.sortMode === 'asc' ? 'desc' : 'asc')
                }}
              >
                <Stack spacing={'2px'}>
                  <SortAscIcon
                    fill={item.sortMode === 'asc' ? '#1890FF' : '#9B9B9B'}
                  />
                  <SortDeskIcon
                    fill={item.sortMode === 'desc' ? '#1890FF' : '#9B9B9B'}
                  />
                </Stack>
              </IconButton>
            )}
            {item.filter && (
              <IconButton onClick={handleOpen}>
                <FilterIcon fill={filter} />
              </IconButton>
            )}
          </Stack>
        )}
      </Stack>
      {item.filter && (
        <Popover
          sx={{
            ...styles.popover,
            visibility: hidden ? 'hidden' : 'visible',
            opacity: hidden ? '0' : '1',
            transition: 'all 0.3s',
          }}
          open={Boolean(anchorEl)}
          onClose={() => handleClose(undefined)}
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          TransitionComponent={Fade}
        >
          {item.filter && item.filter(handleClose, setFilter)}
        </Popover>
      )}
    </TableCell>
  )
}
